module.exports = __webpack_public_path__ + "water-color.png";